import React, { useEffect, useMemo, useState } from 'react';
import { set } from 'lodash';
import ApiService from '../services/ApiService';

export const ApiContext = React.createContext(null);

export function ApiProvider({ children, i18n }) {
  const [locales, setLocales] = useState([
    {
      code: 'ar',
      localName: 'العربية'
    },
    {
      code: 'en',
      localName: 'English'
    },
    {
      code: 'fr',
      localName: 'Français'
    }
  ]);
  const [localesLoaded, setLocalesLoaded] = useState(false);

  const apiService = useMemo(() => new ApiService(), []);

  // onLoad
  useEffect(() => {
    // get locales and translation strings from API
    apiService.getAppTranslations().then(response => {
      // get available
      if (response.data.languages) {
        const apiLocales = response.data.languages.map(lng => ({
          code: lng.code || lng?.i18n_locale?.code,
          localName: lng.localName,
          published: !!lng.published_at || !!lng.publishedAt // v3=published_at, v4=publishedAt
        }));
        setLocales(apiLocales);
        setLocalesLoaded(true);
      }

      const resources = {};

      // process each individual translation
      const setTranslation = t => {
        let locale = resources[t.locale];
        if (!locale) {
            resources[t.locale] = { translation: {} };
            locale = resources[t.locale];
        }
        set(locale.translation, t.key, t.translation);
      };

      // loop through all translations and each nested localization
      for (const t of response.data.appTranslations) {
        setTranslation(t);

        if (t.localizations) {
          for (const l of t.localizations) {
            setTranslation(l);
          }
        }
      }

      // load all languages
      for (const lng in resources) {
        i18n.addResourceBundle(lng, 'translation', resources[lng].translation, true, true);
      }
      })
      .catch((err) => {
        console.error('Could not retrieve app translations', err);
    });
  }, [apiService, i18n]);

  const context = {
    locales,
    localesLoaded,
    apiService
  };
  return <ApiContext.Provider value={context}>{children}</ApiContext.Provider>;
}
